import { departmentService } from "../../../../Api/Services/DepartmentService";
import { SLICE_NAMES, ACTION_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";

// Async Thunk for toggling department status
export const updateDepartmentStatusThunk = createServiceAsyncThunk<
  { status: boolean; message: string },
  { id: number; status: string }
>(
  ACTION_NAMES.UPDATE_DEPARTMENT_STATUS,
  (payload) => departmentService.updateDepartmentStatus(payload),
  ERROR_MESSAGES.UPDATE_DEPARTMENT_STATUS_FAILURE
);

const updateDepartmentStatusSlice = createGenericSlice<
  { status: boolean; message: string },
  { id: number; status: string }
>(SLICE_NAMES.UPDATE_DEPARTMENT_STATUS, updateDepartmentStatusThunk);

export const {
  clearError: clearUpdateDepartmentStatusError,
  clearSuccessMessage: clearUpdateDepartmentStatusSuccess,
} = updateDepartmentStatusSlice.actions;

export default updateDepartmentStatusSlice.reducer;
